import React from "react";
import { Box, Button, Card, CardContent, Chip, Grid, Stack, Typography } from "@mui/material";
import PageContainer from "../../ui/layout/PageContainer";

const LandingPage = () => {
  const quickActions = [
    { label: "Create Candidate", href: "/candidate/create" },
    { label: "Create Employer", href: "/employer/create" },
    { label: "Post Job", href: "/all-jobs" },
    { label: "Launch Campaign", href: "/whatsapp-campaign" },
  ];

  return (
    <PageContainer
      title="Welcome back"
      subtitle="JobsYahan admin command center"
      actions={
        <Stack direction="row" spacing={1} alignItems="center">
          <Chip
            label="Live"
            size="small"
            sx={{
              bgcolor: "rgba(122, 75, 117, 0.12)",
              color: "#7a4b75",
              fontWeight: 600,
            }}
          />
          <Button
            variant="contained"
            size="small"
            sx={{
              borderRadius: 999,
              bgcolor: "#f26d3d",
              "&:hover": { bgcolor: "#e35e2f" },
            }}
            href="/candidate/create"
          >
            Create Candidate
          </Button>
        </Stack>
      }
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card
            sx={{
              height: "100%",
              borderRadius: 4,
              boxShadow: "0 18px 40px rgba(50, 30, 60, 0.1)",
            }}
          >
            <CardContent>
              <Stack spacing={2.5}>
                <Typography variant="h3" sx={{ fontWeight: 700 }}>
                  Operations Overview
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Track critical workflows, monitor candidate pipelines, and keep regional operations aligned in one place.
                </Typography>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                  {quickActions.map((action) => (
                    <Button
                      key={action.label}
                      variant="contained"
                      sx={{
                        borderRadius: 999,
                        bgcolor: "#f26d3d",
                        "&:hover": { bgcolor: "#e35e2f" },
                      }}
                      href={action.href}
                    >
                      {action.label}
                    </Button>
                  ))}
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              height: "100%",
              borderRadius: 4,
              boxShadow: "0 16px 32px rgba(50, 30, 60, 0.08)",
            }}
          >
            <CardContent>
              <Stack spacing={2.5}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  New Member
                </Typography>
                <Stack spacing={2}>
                  {[
                    { label: "New candidates", value: "124" },
                    { label: "Active employers", value: "52" },
                    { label: "Open requisitions", value: "86" },
                  ].map((item) => (
                    <Box
                      key={item.label}
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        bgcolor: "rgba(122, 75, 117, 0.08)",
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {item.label}
                      </Typography>
                      <Typography variant="h5" sx={{ mt: 1, fontWeight: 700 }}>
                        {item.value}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 4, boxShadow: "0 12px 24px rgba(50, 30, 60, 0.08)" }}>
            <CardContent>
              <Stack spacing={1.5}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                  Pipeline Health
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Candidate conversion, offer acceptance, and deployment velocity.
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Chip label="+72%" size="small" sx={{ bgcolor: "rgba(242, 109, 61, 0.15)", color: "#f26d3d" }} />
                  <Chip label="-60%" size="small" sx={{ bgcolor: "rgba(122, 75, 117, 0.12)", color: "#7a4b75" }} />
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 4, boxShadow: "0 12px 24px rgba(50, 30, 60, 0.08)" }}>
            <CardContent>
              <Stack spacing={1.5}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                  Campaign Performance
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  WhatsApp responses and email conversions for the week.
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Chip label="72% open" size="small" sx={{ bgcolor: "rgba(242, 109, 61, 0.15)", color: "#f26d3d" }} />
                  <Chip label="8.4% CTR" size="small" sx={{ bgcolor: "rgba(122, 75, 117, 0.12)", color: "#7a4b75" }} />
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 4, boxShadow: "0 12px 24px rgba(50, 30, 60, 0.08)" }}>
            <CardContent>
              <Stack spacing={1.5}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                  Regional Coverage
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Track hiring density across priority states and cities.
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Chip label="MH + KA" size="small" sx={{ bgcolor: "rgba(122, 75, 117, 0.12)", color: "#7a4b75" }} />
                  <Chip label="22 live hubs" size="small" sx={{ bgcolor: "rgba(242, 109, 61, 0.15)", color: "#f26d3d" }} />
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default LandingPage;
